/** Short device vibration when supported (iOS Safari often no-ops). */
export function haptic(pattern = 12) {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return
    navigator.vibrate(pattern)
  } catch {
    /* ignore */
  }
}

/** Cue that watching is over / your turn begins */
export function hapticWatchEnd() {
  haptic([18, 40, 28])
}

/** Cue that a hold/press started */
export function hapticHoldStart() {
  haptic(14)
}
